export class PredefinedMessage {
  message: string;
  options: Array<string>;

  constructor()
  {
    this.reset();
  }

  reset()
  {
    this.message = '';
    this.options = new Array(4);
  }
}

export class PredefinedMessages {
  messages: PredefinedMessage[];

  setMessages(messages)
  {
    this.messages = messages;
  }
}
